<template>
  <v-data-table
    :headers="headers"
    :items="model.radar_statistics_day_requests"
    :search="search"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
  >
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-row>
          <v-col>
            <!-- Заблаговременности:  -->
            <v-sheet>
              <div>Заблаговременности</div>
              <json-viewer expanded :expand-depth="5" :value="item.valid_times" copyable boxed sort></json-viewer>
            </v-sheet>
          </v-col>
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { WapiRequestType } from "../../../constants";
import { WapiDataType } from "../../../constants";

export default {
  name: "BillingStatiscticsDetail",
  props: {
    model: Object,
    dataType: Number
  },
  data() {
    return {
      wapiRequestType: WapiRequestType,
      wapiDataType: WapiDataType,
      expanded: [],
      singleExpand: false,
      search: "",
      radarHeaders: [
        { text: "Базовое время", value: "base_time" },
        { text: "Дата", value: "date" },
        { text: "Параметр", value: "parameter" },
        { text: "Территория", value: "territory" }
      ]
    };
  },
  computed: {
    headers() {
      return this.radarHeaders;
    }
  },
  methods: {
    getTextPoint(point) {
      if (point) {
        return `[${point.geometry.coordinates[1]}, ${point.geometry.coordinates[0]}]`;
      }

      return "";
    },
    getColor(requestType) {
      if (requestType === this.wapiRequestType.Preset) return "primary";
      if (requestType === this.wapiRequestType.Point) return "success";
      return "grey";
    },
    getLabel(requestType) {
      if (requestType === this.wapiRequestType.Preset) return "Территория";
      if (requestType === this.wapiRequestType.Point) return "Точка";
      if (requestType === this.wapiRequestType.Radar) return "Радар";
      return "Неопределено";
    }
  }
};
</script>